import { TextField } from "@/app/fields";
import type { Errors } from "@/app/useDraft";
import { Field, Form, Select, Switch, Textarea } from "@/ui";
import type { ProfitGuardDraft } from "./profitGuardDraft";

interface Props { draft: ProfitGuardDraft; errors: Errors<ProfitGuardDraft>; set: <K extends keyof ProfitGuardDraft>(k: K, v: ProfitGuardDraft[K]) => void; isNew: boolean; accounts: { value: string; label: string; hint?: string }[] }

/** 利润保护表单的字段（决策 D70）。维度建好后不改，编辑时不显示，改维度就新建一条。 */
export function ProfitGuardForm({ draft, errors, set, isNew, accounts }: Props) {
  return (
    <Form>
      {isNew && (
        <>
          <Field label="账号" required error={errors.account_id}>
            <Select block options={accounts} value={draft.account_id || null} placeholder="选择账号" onChange={(v) => set("account_id", v)} invalid={!!errors.account_id} />
          </Field>
          <TextField id="pg-mcc" label="MCC" required mono value={draft.mcc} error={errors.mcc} onChange={(v) => set("mcc", v.trim())} />
          <TextField id="pg-mnc" label="MNC" mono value={draft.mnc} error={errors.mnc} hint="留空表示全部运营商，具体 MNC 的规则优先" onChange={(v) => set("mnc", v.trim())} />
        </>
      )}
      <TextField id="pg-limit" label="允许最大亏损（USD）" required mono value={draft.loss_limit} error={errors.loss_limit} hint="累计净亏损达到这个金额就停止发送。调低到已越线时保存即熔断；调高不会解除熔断，要手工重置" onChange={(v) => set("loss_limit", v.trim())} />
      <Field label="备注" htmlFor="pg-note"><Textarea id="pg-note" rows={3} value={draft.note} onChange={(e) => set("note", e.target.value)} /></Field>
      {!isNew && <Switch label="启用" checked={draft.status === "active"} onChange={(on) => set("status", on ? "active" : "disabled")} />}
    </Form>
  );
}
